import { Check } from "lucide-react";

export const DeliverySection = ({ formData, update, isStudOrMare }) => (
  <div className="glass-card p-6 space-y-6">
    <h2 className="text-xl text-[#EDEDED] mb-4">Delivery / Exchange Options</h2>

    <div className="space-y-3">
      <label className="flex items-start gap-3 p-4 rounded-xl border cursor-pointer transition-all border-[#3F3F46] hover:border-[#71717A]">
        <input
          type="checkbox"
          checked={formData.pickup_available}
          onChange={(e) => update({ pickup_available: e.target.checked })}
          className="sr-only"
        />
        <div
          className={`w-5 h-5 mt-0.5 rounded border-2 flex items-center justify-center flex-shrink-0 ${
            formData.pickup_available ? "bg-[#D4AF37] border-[#D4AF37]" : "border-[#71717A]"
          }`}
        >
          {formData.pickup_available && <Check className="w-3 h-3 text-black" />}
        </div>
        <div>
          <span className="text-[#EDEDED] font-medium">In-Person Pickup / Exchange</span>
          <p className="text-sm text-[#71717A]">
            Buyer picks up at your location or a mutually agreed meeting point
          </p>
        </div>
      </label>

      <label className="flex items-start gap-3 p-4 rounded-xl border cursor-pointer transition-all border-[#3F3F46] hover:border-[#71717A]">
        <input
          type="checkbox"
          checked={formData.shipping_available}
          onChange={(e) => update({ shipping_available: e.target.checked })}
          className="sr-only"
        />
        <div
          className={`w-5 h-5 mt-0.5 rounded border-2 flex items-center justify-center flex-shrink-0 ${
            formData.shipping_available ? "bg-[#D4AF37] border-[#D4AF37]" : "border-[#71717A]"
          }`}
        >
          {formData.shipping_available && <Check className="w-3 h-3 text-black" />}
        </div>
        <div>
          <span className="text-[#EDEDED] font-medium">Shipping / Transport Available</span>
          <p className="text-sm text-[#71717A]">
            {isStudOrMare
              ? "Semen shipping available or can arrange transport for live cover"
              : "Animal can be shipped to buyer (additional fees may apply)"}
          </p>
        </div>
      </label>

      <label className="flex items-start gap-3 p-4 rounded-xl border cursor-pointer transition-all border-[#3F3F46] hover:border-[#71717A]">
        <input
          type="checkbox"
          checked={formData.delivery_method === "buyer_arranges"}
          onChange={(e) =>
            update({ delivery_method: e.target.checked ? "buyer_arranges" : "in_person" })
          }
          className="sr-only"
        />
        <div
          className={`w-5 h-5 mt-0.5 rounded border-2 flex items-center justify-center flex-shrink-0 ${
            formData.delivery_method === "buyer_arranges"
              ? "bg-[#D4AF37] border-[#D4AF37]"
              : "border-[#71717A]"
          }`}
        >
          {formData.delivery_method === "buyer_arranges" && (
            <Check className="w-3 h-3 text-black" />
          )}
        </div>
        <div>
          <span className="text-[#EDEDED] font-medium">Buyer Arranges Transport</span>
          <p className="text-sm text-[#71717A]">
            Buyer is responsible for arranging and paying for transport
          </p>
        </div>
      </label>
    </div>

    <div>
      <label className="block text-sm text-[#A1A1AA] mb-2">Delivery Notes (optional)</label>
      <textarea
        value={formData.delivery_notes}
        onChange={(e) => update({ delivery_notes: e.target.value })}
        className="input-minimal min-h-[80px]"
        placeholder="Any specific delivery/pickup requirements, preferred transporters, geographic restrictions..."
      />
    </div>
  </div>
);
